<style lang="scss" scoped>
   .breadcrumbs{
      font-size: 10px;
      color: rgb(89, 89, 89);
      
      display: flex;
      font-weight: 500;

      & .item{
         display: flex;
         align-items: center;
         &:hover{
            cursor: pointer;
         }
         &.active{
            font-weight: 500;
            color: rgb(127, 127, 127);
            &:hover{
               cursor: text;
            }
         }
         &:not(:last-child)::after{
            content: '>';
            margin: 0 5px;
         }
         & .feather{
            display: block;
         }
      }
   }
</style>
<template>
   <div class="breadcrumbs">
      <div 
         :class="item.active ? 'item  active':'item'" 
         v-for="(item,index) in items" :key="index"
         @click="$router.push(item.href)"
      >
         {{item.text}}
      </div>
   </div>
</template>
<script>
export default {
  props: {
    items:{
      type: Array,
      validator: (prop) => prop.every(e =>
        typeof e === 'object' && ('text' in e && 'href' in e)
      ),
    }
  },
  data() {
    return {
    };
  },
};
</script>